import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ComponentheaderService } from 'src/app/services/componentheader.service';
import { ToastrService } from 'ngx-toastr';
import { SchoolmanagementService } from 'src/app/services/schoolmanagement.service';
@Component({
  selector: 'app-schoolstudentlist',
  templateUrl: './schoolstudentlist.component.html',
  styleUrls: ['./schoolstudentlist.component.css'],
})
export class SchoolstudentlistComponent implements OnInit {
  constructor(
    public schoolmanager: SchoolmanagementService,
    public toastr: ToastrService,
    public headerinfo: ComponentheaderService,
    public router: ActivatedRoute,
    public route: Router
  ) {
    headerinfo.setHeaderDisplay('School Student List', [], []);
  }

  students: any;
  collection: any;
  p: number;
  itemsPerPage = 25;
  totalItems: any;
  schoolid: any;
  data: any;

  async ngOnInit() {
    //  debugger;
    //this.schoolid = this.router.snapshot.queryParams.schoolid;

    let schdata: any = await this.schoolmanager.getSchoolFromSubdomain();

      this.schoolid = schdata.id;
    // debugger;
    let _schoolName = schdata.schoolName;
    this.headerinfo.setHeaderDisplay(
      `School Students'`,
      [
        {
          displaytext: _schoolName,
          route: `/user/schoolhome`//,
          // params: { schoolID: this.schoolid },
        },
        {
          displaytext: `Students`,
          route: `/user/schoolstudentlist`//,
          //params: this.router.snapshot.queryParams,
        },
      ],
      []
    );

    this.p = 1;
    this.data = await this.schoolmanager
      .getStudentsfromschoolid(this.schoolid, 1, this.itemsPerPage)
      .toPromise()
      .catch((err) => {
        this.toastr.error(err);
        this.route.navigate(['/user/schoolhome']//, 
        // {
        //   queryParams: { schoolID: this.schoolid },
        // }
        );
        return;
      })
      .finally(() => this.headerinfo.pageLoadingDone(this));
      
    this.students = this.data.students;
    if (!this.students || this.students.length == 0) {
      this.toastr.error(`No Student enrolled`);
      this.route.navigate(['/user/schoolhome']//, 
      // {
      //   queryParams: { schoolID: this.schoolid },
      // }
      );
    }

    this.totalItems = this.data.studentcount;
    //debugger;
  }

  async getPage(page) {
    //debugger;
    this.data = await this.schoolmanager
      .getStudentsfromschoolid(this.schoolid, page, this.itemsPerPage)
      .toPromise()
      .catch((err) => {
        this.toastr.error(err);
        this.route.navigate(['/user/schoolhome']//, 
        // {
        //   queryParams: { schoolID: this.schoolid },
        // }
        );
        return;
      })
      .finally(() => this.headerinfo.pageLoadingDone(this));

    this.students = this.data.students;
    // this.students.splice(2);
    this.totalItems = this.data.studentcount;

    //  console.log("Page",page);
  }

  export() {
    this.schoolmanager
      .downloadSchoolStudent(this.schoolid)
      .subscribe((response: any) => {
        const url = window.URL.createObjectURL(response);
        window.open(url);
      }),
      (error: any) => console.log('Error downloading the file'),
      () => console.info('File downloaded successfully');
  }
}
